(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buf-design-system"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = document.querySelectorAll('.buf-reveal');
    if (!('IntersectionObserver' in window) || reduce) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
    document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.buf-reveal').forEach(function (el) { el.classList.add('is-in'); }); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buf-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buf-gallery')) {
    customElements.define('buf-gallery', class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('[data-stage]');
        this.slides = Array.from(this.querySelectorAll('.buf-gallery__slide'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        if (!this.stage || this.slides.length === 0) return;
        this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(Number(t.dataset.thumb))));
        this.querySelectorAll('[data-dir]').forEach((b) => b.addEventListener('click', () => this.goTo(this.current() + Number(b.dataset.dir))));
        this.stage.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.current() + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.current() - 1); } });
        this.stage.addEventListener('scroll', () => { clearTimeout(this.t); this.t = setTimeout(() => this.mark(this.current()), 80); }, { passive: true });
      }
      current() { const w = this.stage.clientWidth || 1; return Math.round(this.stage.scrollLeft / w); }
      goTo(i) { const n = this.slides.length; const idx = ((i % n) + n) % n; this.stage.scrollTo({ left: idx * this.stage.clientWidth, behavior: 'smooth' }); this.mark(idx); }
      mark(idx) { this.thumbs.forEach((t, j) => { t.setAttribute('aria-selected', j === idx ? 'true' : 'false'); if (j === idx && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buf-sticky-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buf-sticky-purchase')) {
    customElements.define('buf-sticky-purchase', class extends HTMLElement {
      connectedCallback() {
        this.main = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
        if (!this.main) return;
        this.button = this.querySelector('[data-sticky-submit]');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        this.quantity = this.querySelector('[data-sticky-quantity]');
        this.error = this.querySelector('[data-sticky-error]');
        this.mobile = matchMedia('(max-width:749px)');
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        };
        this.onClick = () => {
          const source = this.main.querySelector('product-form [type="submit"]');
          const form = source?.form;
          if (!form || this.button.disabled || source.disabled || source.getAttribute('aria-disabled') === 'true') return;
          this.button.disabled = true;
          form.requestSubmit(source);
          this.schedule();
        };
        this.button.addEventListener('click', this.onClick);
        window.addEventListener('scroll', this.schedule, { passive:true });
        window.addEventListener('resize', this.schedule, { passive:true });
        this.mobile.addEventListener('change', this.schedule);
        this.main.addEventListener('input', this.schedule);
        this.main.addEventListener('change', this.schedule);
        this.observer = new MutationObserver((records) => {
          if (records.some(record => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(document.body, { subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['class','disabled','aria-disabled','hidden','open','style','value'] });
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this);
        document.body.classList.add('buf-mobile-purchase-enabled');
        this.sync();
      }
      setText(node, value) { if (node.textContent !== value) node.textContent = value; }
      sync() {
        const source = this.main.querySelector('product-form [type="submit"]');
        if (!source) { this.hidden = true; return; }
        const loading = source.classList.contains('loading');
        const disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
        if (this.button.disabled !== disabled) this.button.disabled = disabled;
        this.button.setAttribute('aria-busy', String(loading));
        const sourceLabel = [...source.querySelectorAll('span')].find(node => !node.classList.contains('hidden') && !node.classList.contains('visually-hidden'));
        this.setText(this.label, loading ? this.dataset.loadingLabel : sourceLabel?.textContent.trim() || source.textContent.trim());
        const sourcePrice = this.main.querySelector(`[id="price-${this.dataset.sectionId}"]`);
        const onSale = sourcePrice?.querySelector('.price--on-sale');
        const currentPrice = sourcePrice?.querySelector(onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
        if (currentPrice) this.setText(this.price, currentPrice.textContent.trim());
        const quantity = this.main.querySelector('[name="quantity"]')?.value || '1';
        this.setText(this.quantity, `${this.querySelector('[data-quantity-label]').textContent}: ${quantity}`);
        const errorWrapper = this.main.querySelector('.product-form__error-message-wrapper');
        const errorMessage = errorWrapper && !errorWrapper.hidden ? errorWrapper.querySelector('.product-form__error-message')?.textContent.trim() : '';
        this.setText(this.error, errorMessage || '');
        this.error.hidden = !errorMessage;
        const overlayOpen = [...document.querySelectorAll('cart-drawer.active, #cart-notification.active, product-modal[open], dialog[open], [role="dialog"][aria-modal="true"], menu-drawer details[open], .shopify-pc__banner, .shopify-pc__prefs, [data-csm-data-container="true"], .isense-csm-cmp-body, .cc-settings-dialog, .csm-native-mobile-wrapper')].some(node => {
          const rect = node.getBoundingClientRect();
          const style = getComputedStyle(node);
          return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
        });
        const hidden = !this.mobile.matches || source.getBoundingClientRect().bottom > 0 || overlayOpen;
        if (this.hidden !== hidden) this.hidden = hidden;
        if (!hidden) {
          const height = `${Math.ceil(this.getBoundingClientRect().height)}px`;
          if (document.body.style.getPropertyValue('--buf-purchase-height') !== height) document.body.style.setProperty('--buf-purchase-height', height);
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        window.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        this.mobile?.removeEventListener('change', this.schedule);
        this.main?.removeEventListener('input', this.schedule);
        this.main?.removeEventListener('change', this.schedule);
        this.button?.removeEventListener('click', this.onClick);
        document.body.classList.remove('buf-mobile-purchase-enabled');
        document.body.style.removeProperty('--buf-purchase-height');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
